<div class="mech-diag-content">
	<app-dvs-chart [error]="errormessage" [options]="spectrumoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="sampleoptions"></app-dvs-chart>
</div>